import React, { useContext } from 'react';
import NewCommitButton from '../NewCommitButton';
import CustomerLanePeriodSelector from './CustomerLanePeriodSelector';
import Grid from './Grid';
import QuickFilters from './QuickFilters';
import ClearQuickFiltersButton from './QuickFilters/ClearQuickFiltersButton';
import FilterPlates from '../FilterPlates';
import Row from '../Common/Row';
import Settings from './Settings';
import OmniSearch from '../OmniSearch';
import DeleteCommitmentPopup from './DeleteCommitmentPopup';
import EndCommitmentPopup from './EndCommitmentPopup';
import PermissionGates from '../PermissionGates';
import PERMISSIONS from '../../permissionDefinitions';
import { CUSTOMER_LANE_COMMITMENTS } from '../../constants';
import WorkSpaceContext from '../../contexts/WorkSpaceContext';
import BoardContext from '../../contexts/BoardContext';
import Typography from 'kingpin/atoms/Typography';
import V3PublishOrShareButton from '../../screens/V3/Content/V3PublishOrShareButton';
import V3ContentBackButton from '../../screens/V3/Content/V3ContentBackButton';
import {
  BoardFilterBar,
  BoardMainContent,
  BoardQuickFilterBounds,
  BoardTopBar,
  BoardWrapper,
} from './styles';

const D_DATA_TYPES = [CUSTOMER_LANE_COMMITMENTS];

const CustomerLaneCommitBoard = ({
  board,
  onQuickFilterChanged,
  onManualFilterChanged,
}: {
  board: Board;
  onQuickFilterChanged: () => void;
  onManualFilterChanged: () => void;
}) => {
  const { quickFilters } = useContext(BoardContext);
  const { workSpace } = useContext(WorkSpaceContext);
  const isWorkSpace = !!workSpace;
  const hasQuickFilters = quickFilters.length > 0;

  return (
    <BoardWrapper data-testid="CustomerLaneCommitBoard">
      <BoardTopBar>
        <Row centerAlign>
          <V3ContentBackButton />
          <Typography.Header type="H5">{board.name}</Typography.Header>
        </Row>
        <PermissionGates.Has
          requiredPermission={
            PERMISSIONS.CUSTOMER_COMMITMENTS.MANAGE_COMMITMENTS
          }
        >
          <Row centerAlign style={{ gap: 8 }}>
            <V3PublishOrShareButton />
            <NewCommitButton />
            <CustomerLanePeriodSelector />
            <Settings />
          </Row>
        </PermissionGates.Has>
      </BoardTopBar>
      <BoardFilterBar hasBorder={hasQuickFilters}>
        <div style={{ marginRight: 8, width: 150 }}>
          <OmniSearch.DrillDownBuilder
            dataTypes={D_DATA_TYPES}
            onManualFilterChanged={onManualFilterChanged}
          />
        </div>
        <FilterPlates onManualFilterChanged={onManualFilterChanged} />
      </BoardFilterBar>
      {hasQuickFilters && (
        <BoardFilterBar>
          <BoardQuickFilterBounds>
            <QuickFilters onQuickFilterChanged={onQuickFilterChanged} />
          </BoardQuickFilterBounds>
          <ClearQuickFiltersButton
            onQuickFilterChanged={onQuickFilterChanged}
          />
        </BoardFilterBar>
      )}
      <BoardMainContent
        isWorkSpace={isWorkSpace}
        hasQuickFilters={hasQuickFilters}
      >
        <Grid />
      </BoardMainContent>
      <DeleteCommitmentPopup />
      <EndCommitmentPopup />
    </BoardWrapper>
  );
};

export default CustomerLaneCommitBoard;
